<template>
  <div class="head">
    <pauseIcon color="#ffffff" />

    <!-- QA Tool -->
    <div class="qaButt" @click="showQA = true" v-if="$store.state.qa">
      {{ $store.state.v }}
    </div>
    <teleport to="#app">
      <ModalQA v-if="showQA" @finish="showQA = false" />
    </teleport>

    <Menu />

    <div class="date center"><Clock />{{ fDate }}</div>
    <div class="moneyPop sideMargin16">
      <div>
        <img src="@/assets/img/coin.svg" alt="Coins" />
        <span> {{ fMoney }}</span>
      </div>
      <div>
        <img src="@/assets/img/pop.svg" alt="Population" />
        <span>{{ fPopulation }}</span>
      </div>
    </div>

    <div class="stats sideMargin16">
      <div v-if="healed > 0">
        <img src="@/assets/img/pop-healed.svg" alt="Healed" />
        <span>{{ fHealed }}</span>
      </div>

      <div>
        <img src="@/assets/img/pop-infected.svg" alt="Infected" />
        <span>{{ fInfected }}</span>
      </div>
      <div v-if="dead > 1">
        <img src="@/assets/img/pop-dead.svg" alt="Dead" /><span>{{
          fDead
        }}</span>
      </div>
    </div>

    <LockDown v-if="$store.state.vaccineStatus === 'Unlocked'" />
  </div>
</template>

<script>
import Clock from "@/components/Clock.vue";
import nFormatter from "@/mixins/nFormatter.js";
import LockDown from "@/components/LockDown.vue";
import ModalQA from "@/components/ModalQA.vue";
import pauseIcon from "@/components/svg/PauseIcon.vue";
import Menu from "@/components/Menu.vue";

export default {
  name: "Header",
  mixins: [nFormatter],
  components: { Clock, LockDown, ModalQA, Menu, pauseIcon },
  data() {
    return {
      localDate: 0,
      interval: {},
      mortlality: 3,
      showQA: false,
    };
  },
  computed: {
    fDate: function() {
      return this.localDate.toLocaleString("default", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    time: function() {
      return this.$store.state.time;
    },

    pop: function() {
      return this.$store.state.population;
    },

    dead: function() {
      return this.$store.state.dead;
    },

    infectedForDead: function() {
      return this.$store.state.infectedForDead;
    },

    infected: function() {
      return this.$store.state.infected;
    },

    healed: function() {
      return this.$store.state.healed;
    },
    fPopulation: function() {
      if (this.pop - this.dead <= 0) {
        return 0;
      } else {
        return this.nFormatter(Math.round(this.pop - this.dead), 2);
      }
    },

    fInfected: function() {
      if (this.infected > 1 && this.infected < this.pop) {
        return this.nFormatter(Math.round(this.infected), 2);
      } else if (this.infected > this.pop) {
        return this.fPopulation;
      } else {
        return 1;
      }
    },

    fHealed: function() {
      return this.nFormatter(Math.round(this.$store.state.healed), 2);
    },

    fDead: function() {
      return this.nFormatter(Math.round(this.dead), 2);
    },

    fMoney: function() {
      return this.$store.state.money
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    infectionRate: function() {
      let i = this.infected;
      if (i > 0 && i < 100) {
        return 2.4;
      } else if (i > 100 && i < 10000) {
        return 1.9;
      } else if (i > 10000 && i < 100000) {
        return 1.8;
        // 10K - 10M
      } else if (i > 100000 && i < 10000000) {
        return 1.7;
      }
      // 10m - 100m
      else if (i > 10000000 && i < 100000000) {
        return 1.6;
        // 100m-500m
      } else if (i > 100000000 && i < 50000000) {
        return 1.3;
      } else {
        return 1.05;
      }
    },

    infectForDeadRate: function() {
      let i = this.infectedForDead;
      if (i > 0 && i < 100) {
        return 2.4;
      } else if (i > 100 && i < 10000) {
        return 1.9;
      } else if (i > 10000 && i < 100000) {
        return 1.8;
        // 10K - 10M
      } else if (i > 100000 && i < 10000000) {
        return 1.7;
      }
      // 10m - 100m
      else if (i > 10000000 && i < 100000000) {
        return 1.6;
        // 100m-500m
      } else if (i > 100000000 && i < 50000000) {
        return 1.3;
      } else {
        return 1.05;
      }
    },
  },

  mounted: function() {
    let sDate = new Date(Date.parse(this.$store.state.date));
    this.localDate = new Date(sDate.setDate(sDate.getDate() + this.time - 1));
  },

  watch: {
    time: function() {
      this.tick();
    },
  },

  methods: {
    // Days counting, infection logic
    tick: function() {
      let sDate = new Date(Date.parse(this.$store.state.date));
      this.localDate = new Date(sDate.setDate(sDate.getDate() + this.time));

      if (!this.$store.state.lockdown) {
        // infected count
        const newInfected = this.infected * this.infectionRate - this.healed;
        this.$store.commit("setInfected", newInfected);

        // infected for dead
        const newInfectedForDead =
          this.infectedForDead * this.infectForDeadRate;
        if (this.time >= 10) {
          this.$store.commit("setInfectedForDead", newInfectedForDead);
        }
        //  counting dead
        const dead = (this.infectedForDead / 100) * this.mortlality;
        this.$store.commit("addDead", dead);
      } else {
        this.$store.commit("setInfected", this.infected - this.healed);
      }

      // LOST
      if (this.pop - this.dead < 0) {
        this.resetGame("/over");
        this.$router.push("/over");
        this.track("level_end", "viruzz 01", "fail");
        this.track(
          "LOST",
          "LOST",
          "Lost money: " + this.$store.state.money + " healed: " + this.healed
        );
      }

      // WIN
      if (this.infected < 2 && this.time > 10) {
        this.track("level_end", "viruzz 01", "success");
        this.resetGame("/win");
        this.track(
          "WIN",
          "WIN",
          "Win money: " + this.$store.state.money + " healed: " + this.healed
        );
      }

      this.track("tick", "tick", "tick: " + this.time);
    },

    resetGame: function(path) {
      this.$store.commit("setFinals", this.fDate);
      // document.removeEventListener("visibilitychange", () => {}); doesn't work... whyyyy

      setTimeout(() => {
        this.date = new Date();
        this.$router.push(path);
      }, 1);
    },

    outside: function() {
      console.log("outside");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.head {
  width: 100%;
  height: 160px;
  background: #000 url("../assets/img/bg-header.jpeg") center no-repeat;
  background-size: auto 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  font-family: "Roboto Mono", monospace;
  position: fixed;
  top: 0;
  z-index: 9;
  p {
    color: #fff;
    margin: 0;
  }

  .date {
    text-align: center;
    flex-direction: row;
    font-size: 14px;
    margin-top: 16px;
    font-weight: 600;

    svg {
      margin-right: 8px;
    }
  }
  .moneyPop {
    display: flex;
    margin-top: 24px;
    justify-content: space-between;
    flex-grow: 1;
    div {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        margin: 0 8px;
      }
      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }

  .stats {
    display: flex;
    justify-content: space-evenly;
    margin-bottom: 8px;

    div {
      display: flex;
      align-items: center;

      span {
        font-weight: 600;
      }

      img {
        margin-right: 8px;
      }
    }
  }

  .sideMargin16 {
    margin-left: 16px;
    margin-right: 16px;
  }
}

.qaButt {
  font-size: 12px;
  position: absolute;
  top: 0;
  left: 50px;
  background: rgba(255, 255, 255, 0.25);
  padding: 8px;
  color: #fff;
  opacity: 0.5;
}
</style>
